<template>
  <v-app>
    <MenuBar
      :isLogged="isLogged"
      :links="filteredMenu"
      :user="loggedUser"
      @event="logout"
    />

    <PageBar
      :isLogged="isLogged"
      :title="pageTitle"
      :show="showPageBar"
      @event="logout"
    />

    <v-main
      :class="{ 'mt-10': showPageBar }"
      :style="showPageBar ? '' : 'margin-top: -1.5em'"
    >
      <v-container v-if="vAlert.show">
        <v-alert dark dismissible :type="vAlert.type">
          <div v-html="vAlert.text"></div>
        </v-alert>
      </v-container>

      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import auth from "./auth";

import MenuBar from "@/components/MenuBar";
import PageBar from "@/components/PageBar";

export default {
  name: "App",

  components: {
    MenuBar,
    PageBar,
  },

  data: () => ({
    drawer: false,
    isUserLogged: false,
    menu: [
      {
        to: "/",
        icon: "mdi-home",
        text: "Inicio",
      },
      {
        to: "/docentes",
        icon: "mdi-teach",
        text: "Docentes",
        logged: true,
      },
      {
        to: "/tronco-comun",
        icon: "mdi-chart-tree",
        text: "Tronco común",
        logged: true,
      },
      {
        to: "/carreras",
        icon: "mdi-school",
        text: "Carreras",
        logged: true,
      },
      {
        to: "/periodos",
        icon: "mdi-calendar-month",
        text: "Periodos",
        logged: true,
      },
      {
        to: "/grupos",
        icon: "mdi-account-group",
        text: "Grupos",
        logged: true,
      },
      {
        to: "/carga-academica/periodo-actual",
        icon: "mdi-view-dashboard",
        text: "Carga Académica",
        logged: true,
      },
      {
        to: "/tutorias/periodo-actual",
        icon: "mdi-account-supervisor",
        text: "Tutorias",
        logged: true,
      },
      // {
      //   icon: "mdi-dots-horizontal",
      //   text: "Sub-menu",
      //   subLinks: [
      //     {
      //       text: "Opción 1",
      //       to: "/sub-menu/opcion-1",
      //     },
      //     {
      //       text: "Opción 2",
      //       to: "/sub-menu/opcion-2",
      //     },
      //     {
      //       text: "Opción 3",
      //       to: "/sub-menu/opcion-3",
      //     },
      //   ],
      // },
      // {
      //   to: "/acerca",
      //   icon: "mdi-information-outline",
      //   text: "Acerca",
      // },
      // {
      //   to: "/contactanos",
      //   icon: "mdi-at",
      //   text: "Contáctanos",
      // },
    ],
  }),
  computed: {
    ...mapState([
      "isLogged",
      "loggedUser",
      "pageTitle",
      "showPageBar",
      "vAlert",
    ]),
    filteredMenu() {
      return this.isLogged
        ? this.menu
        : this.menu.filter((item) => {
            return !item.logged;
          });
    },
  },
  methods: {
    ...mapMutations(["updateLogged"]),
    logout() {
      auth.removeUserLogged();
      this.updateLogged(null);
      if (this.$route.path != "/") this.$router.push("/");
    },
    async stillLogged(user) {
      if (user != null) {
        const activeUser = await auth.stillLogged(user);
        this.updateLogged(activeUser);
      }
    },
  },
  async mounted() {
    let user = await auth.getUserLogged();
    this.updateLogged(user);
  },
};
</script>

<style>
.text-xs {
  font-size: 50%;
}
.text-sm {
  font-size: 80%;
}
.text-md {
  font-size: 125%;
}
.text-lg {
  font-size: 175%;
}
.text-xl {
  font-size: 300%;
}
</style>
